<app-address
	[name]="label"
	[address]="address$ | async"
	[skeletonLoading]="skeletonLoading"
	(onAddressUpdate)="addressChanged($event)"
	[state]="cardState$ | async"
	[enableCountrySelect]="false"
	[labelIcon]="AI_ICON"
	[labelToolTip]="showLabelToolTip$ | async"
	[labelIconClasses]="AI_CLASSES"
	[testHook]="testHooks.Address"
>
</app-address>
<ui-note
	*ngIf="showWarningNote$ | async"
	title="Address Mismatch!"
	[type]="NOTE_TYPES.WARNING"
>
	<p class="p-sm">
		We didn't find a matching address in Canada Post for the property address
		described in the APS. Please review and update accordingly.
	</p>
</ui-note>
